import { elementDefinitions, elementTypes } from 'crazyEditor/components/Elements/index';
import { isStaticElement, omitStaticElementsAndHiddenElements, omitStaticElements } from './elementStaticUtils';
import _ from 'lodash';

function mapElementOrderbyZIndex(elements) {
  return _.map(omitStaticElementsAndHiddenElements(elements), (element) => parseInt(element.compProps.zIndex, 10));
}

export function getHiddenElements(elements) {
  const hiddenElements = {};
  _.forEach(elements, (element) => {
    if (element.hidden) {
      hiddenElements[element.id] = element;
    }
  });
  return hiddenElements;
}

export function getVisibleElements(elements) {
  const visibleElements = {};
  _.forEach(elements, (element) => {
    if (!element.hidden) {
      visibleElements[element.id] = element;
    }
  });
  return visibleElements;
}

export function getMaxZIndex(elements) {
  return _.max(mapElementOrderbyZIndex(elements)) || 0;
}

export function getMinZIndex(elements) {
  return _.min(mapElementOrderbyZIndex(elements)) || 0;
}

export function isChildElementId(elementId) {
  return elementId.indexOf('_child_') !== -1;
}

export function isChildElement(element) {
  return element.parentId;
}

export const isRichTextInsideTabsElement = (element) => isChildElement(element) && element.parentType === elementTypes.TabsElement && element.type === elementTypes.RichTextElement;

export function isChildIdBelongsToParentId(childId, parentId) {
  const childIdArr = childId.split('_');
  return `${childIdArr[0]}_${childIdArr[1]}` === parentId;
}
